import { Button } from "~/components/ui/button";
import { Skeleton } from "~/components/ui/skeleton";

export function PullRequestTimelineLoading() {
  return (
    <div className="space-y-3 px-4 py-4" aria-label="Loading timeline" aria-busy="true">
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-4/5" />
    </div>
  );
}

export function PullRequestTimelineEmpty() {
  return (
    <div className="px-4 py-8 text-center text-sm text-muted-foreground">
      No timeline activity is available from this provider yet.
    </div>
  );
}

export function PullRequestTimelineError({
  error,
  onRetry,
}: {
  readonly error: Error;
  readonly onRetry: () => void;
}) {
  return (
    <div className="flex flex-col items-start gap-3 px-4 py-6">
      <p className="text-sm text-destructive-foreground">
        Timeline could not be loaded: {error.message}
      </p>
      <Button type="button" size="sm" variant="outline" onClick={onRetry}>
        Retry timeline
      </Button>
    </div>
  );
}
